import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { List, X } from '@phosphor-icons/react';

const navLinks = [
  { href: '#about', label: 'About' },
  { href: '#services', label: 'Services' },
  { href: '#gallery', label: 'Projects' },
  { href: '#blog', label: 'Blog' },
  { href: '#contact', label: 'Contact' },
];

const Header = ({ onQuoteClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header
        data-testid="main-header"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'glass-header py-3' : 'bg-transparent py-5'
        }`}
      >
        <div className="container-custom flex items-center justify-between">
          <a href="#hero" onClick={(e) => scrollToSection(e, '#hero')} data-testid="logo-link" className="flex items-center">
            <img src="/rimsie-logo-final.png" alt="Rimsie Constructions Pty Ltd" className="h-14 md:h-16 w-auto" />
          </a>

          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} onClick={(e) => scrollToSection(e, link.href)}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className="text-heading/70 hover:text-heading text-sm font-medium tracking-wide transition-colors duration-200">
                {link.label}
              </a>
            ))}
            <button onClick={onQuoteClick} data-testid="nav-cta-button" className="btn-primary text-sm px-6 py-3">
              Get a Free Quote
            </button>
          </nav>

          <button onClick={() => setIsMobileMenuOpen(true)} data-testid="mobile-menu-button"
            className="lg:hidden text-heading p-2" aria-label="Open menu">
            <List size={28} weight="light" />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/60 z-50 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} />
            <motion.div initial={{ x: '100%' }} animate={{ x: 0 }} exit={{ x: '100%' }}
              transition={{ type: 'tween', duration: 0.3 }} data-testid="mobile-menu"
              className="fixed right-0 top-0 bottom-0 w-80 bg-secondary-bg z-50 lg:hidden">
              <div className="p-6">
                <div className="flex justify-between items-center mb-10">
                  <span className="text-heading font-heading text-lg">Menu</span>
                  <button onClick={() => setIsMobileMenuOpen(false)} data-testid="mobile-menu-close"
                    className="text-heading p-2" aria-label="Close menu">
                    <X size={24} weight="light" />
                  </button>
                </div>
                <nav className="flex flex-col gap-6">
                  {navLinks.map((link) => (
                    <a key={link.href} href={link.href} onClick={(e) => scrollToSection(e, link.href)}
                      data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                      className="text-heading/70 hover:text-heading text-lg font-medium transition-colors">
                      {link.label}
                    </a>
                  ))}
                  <button onClick={() => { setIsMobileMenuOpen(false); onQuoteClick(); }}
                    data-testid="mobile-nav-cta" className="btn-primary text-center mt-4">
                    Get a Free Quote
                  </button>
                </nav>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
